import React from "react";
import { DrawerNavigation } from "@tumomento/ui";
import { classNamesList, goToWizardQuote } from "@/utils/components";
import useNavbarLogic from "./useNavbarLogic";
import "./Navbar.scss";
import { Location } from "@/interfaces/Location";
import { Breadcrumb } from "../Breadcrumb";

export const Navbar = ({
  location,
  showBreadcrumbs = false,
}: {
  location?: Location;
  showBreadcrumbs?: boolean;
}) => {
  const {
    isMobile,
    NavbarMenuDesktop,
    NavbarMenuMobile,
    openDrawer,
    setOpenDrawer,
    showCTAButton,
  } = useNavbarLogic();

  return showBreadcrumbs ? (
    <nav
      className={classNamesList(
        `Navbar ${!showCTAButton && "-active"}`,
        "w100 flex align-center justify-between px-4"
      )}
    >
      {location && (
        <Breadcrumb location={location} invertColor={showCTAButton} />
      )}
    </nav>
  ) : (
    <nav
      className={classNamesList(
        `Navbar ${!showCTAButton && "-active"}`,
        "w100 flex align-center justify-between px-4"
      )}
    >
      <a href={isMobile ? "/blog" : "/"} className={"NavbarLogo"}>
        <span
          className="showMobile titleblog"
          style={showCTAButton ? { color: "#18C9B4" } : {}}
        >
          El blog
        </span>
        <img
          className="showDesktop"
          src={
            showCTAButton
              ? "/images/logo-momento.svg"
              : "/images/logo-momento-green.svg"
          }
          height={16}
          width={144}
          alt={"Momento"}
        />
      </a>
      <div className="showMobile">
        <DrawerNavigation
          aria-label="Menu"
          aria-labelledby="Menu"
          onClose={() => {
            setOpenDrawer(false);
          }}
          onOpen={() => {}}
          onClickButton={() => setOpenDrawer(true)}
          open={openDrawer}
          iconColor={showCTAButton ? "green3" : "white"}
          className={"NavbarDrawerNavigation"}
        >
          <div className={classNamesList("flex row p-6 center-content-h")}>
            <button
              type="button"
              aria-label="close"
              className="momento-btn base menudrawer"
              onClick={() => setOpenDrawer(false)}
            >
              <img src="/images/close.svg" width="24px" height="24px" />
            </button>
          </div>
          <NavbarMenuMobile />
        </DrawerNavigation>
      </div>
      <div
        className={`btncta ${!showCTAButton && "-activecta"}`}
        onClick={() => goToWizardQuote()}
      >
        Cotizar
      </div>
      <NavbarMenuDesktop />
    </nav>
  );
};

//export default Navbar;
